<template>
  <div class="card__body-list">

    <div class="card__body-item" v-if="product.nutrition.energy">
      <div class="card__body-item__title">{{ product.nutrition.energy.toFixed(0) }}</div>
      <div class="card__body-smalltext">Ккал</div>
    </div>

    <div class="card__body-item" v-if="product.nutrition.proteins">
      <div class="card__body-item__title">{{ product.nutrition.proteins.toFixed(0) }} г</div>
      <div class="card__body-smalltext">Белки</div>
    </div>

    <div class="card__body-item" v-if="product.nutrition.fats">
      <div class="card__body-item__title">{{ product.nutrition.fats.toFixed(0) }} г</div>
      <div class="card__body-smalltext">Жиры</div>
    </div>

    <div class="card__body-item" v-if="product.nutrition.carbs">
      <div class="card__body-item__title">{{ product.nutrition.carbs.toFixed(0) }} г</div>
      <div class="card__body-smalltext">Углеводы</div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'TheNutritionProduct',
  props: {
    product: {
      type: Object,
      require: true,
    }
  },
}
</script>

<style lang="scss" scoped>

</style>